<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <b-form-input v-if="!client" class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
            :placeholder="$t('keyword')"></b-form-input>
          <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
            { value: null, text: this.$t('allStatus') },
            { value: '0', text: this.$t('waiting') },
            { value: '1', text: this.$t('confirmed') },
            { value: '2', text: this.$t('canceled') },
          ]"></form-select>
          <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-1" :options="[
            { value: null, text: this.$t('allTypes') },
            { value: 'new', text: this.$t('new') },
            { value: 'newDivide', text: this.$t('newDivide') },
            { value: 'setup', text: this.$t('setup') },
            { value: 'upgrade', text: this.$t('upgrade') },
            { value: 'extend', text: this.$t('extend') },
            { value: 'user', text: this.$t('user') },
            { value: 'unlimited', text: 'Flex' },
            { value: 'promo', text: this.$t('promo') }
          ]"></form-select>
          <form-select :model="filterFormModel" attribute="isExtendAgain" class="mr-1 mb-1" :options="[
            { value: null, text: this.$t('allReSign') },
            { value: 'true', text: this.$t('reSigned') },
            { value: 'false', text: this.$t('notReSigned') },
          ]"></form-select>
          <form-select :model="filterFormModel" attribute="excludeFromCommissionReport" class="mr-1 mb-1" :options="[
            { value: null, text: this.$t('allCommissionReport') },
            { value: 'true', text: this.$t('excludedFromCommissionReport') },
            { value: 'false', text: this.$t('includedInCommissionReport') },
          ]"></form-select>
          <admin-user-select v-if="!client" class="mr-1 mb-1" :model="filterFormModel" attribute="sales"
            :place-holder="$t('chooseBD')"></admin-user-select>
          <admin-user-select v-if="!client" class="mr-1 mb-1" :model="filterFormModel" attribute="account"
            :place-holder="$t('chooseAM')"></admin-user-select>
          <client-select v-if="!client" :model="filterFormModel" attribute="client" :isFilter="true"
            class="mr-1 mb-1"></client-select>
          <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1" :defaultShortcut="3"
            from-attribute="createTimeFrom" to-attribute="createTimeTo"></time-range-picker>
          <time-range-picker :model="filterFormModel" :label="$t('confirmTime')" class="mr-1 mb-1"
            from-attribute="confirmTimeFrom" to-attribute="confirmTimeTo"></time-range-picker>
          <time-range-picker :model="filterFormModel" :label="$t('expireTime')" class="mr-1 mb-1"
            from-attribute="expireTimeFrom" to-attribute="expireTimeTo"></time-range-picker>
          <div class="form-inline mr-1 mb-1">
            <span class="mr-1">{{ $t('monthsSinceActive') }}:</span>
            <b-form-input type="number" min="0" class="mr-1" style="width: 80px"
              v-model="filterFormModel.monthsSinceActiveFrom" :placeholder="$t('monthFrom')"
              v-on:keydown.enter="load"></b-form-input>
            <b-form-input type="number" min="0" style="width: 80px" v-model="filterFormModel.monthsSinceActiveTo"
              :placeholder="$t('monthTo')" v-on:keydown.enter="load"></b-form-input>
          </div>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-sorting" v-if="!client">
        <div class="row">
          <div class="col-lg-12 c-sorting__right">
            <div class="c-sorting__btn">
              <!--                <divide v-if="['admin', 'owner', 'account', 'operationsManager'].includes($store.state.user.role)"></divide>-->
              <setup v-if="['admin', 'owner', 'account', 'operationsManager'].includes($store.state.user.role)"></setup>
              <buy-new
                v-if="['admin', 'owner', 'account', 'operationsManager'].includes($store.state.user.role)"></buy-new>
              <buy-user
                v-if="['admin', 'owner', 'account', 'operationsManager'].includes($store.state.user.role)"></buy-user>
              <extend v-if="['admin', 'owner', 'account', 'operationsManager'].includes($store.state.user.role)">
              </extend>
              <!--                <unlimited v-if="['admin', 'owner', 'account', 'operationsManager'].includes($store.state.user.role)"></unlimited>-->
              <export :filter="filterFormModel" :total-count="itemCount"
                v-if="['admin', 'owner', 'account', 'manager', 'operationsManager', 'kpiSales', 'salesAssistant', 'tech', 'accountant'].includes($store.state.user.role)">
              </export>
            </div>
          </div>
        </div>

      </div>
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
              v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
              @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row">
          <div class="col-10">
            <b class="text-info text-right">{{ $t('sum') }}</b>
          </div>
          <div class="col-2">
            <b-spinner v-if="totalLoading" small></b-spinner>
            <span v-else>{{ total | numFormat }}</span>
          </div>
        </div>
        <div class="row c-smart-table__title">
          <div class="col-lg-3" v-if="!client">{{ $t('client') }}</div>
          <div :class="`col-lg-${client ? 4 : 3}`">{{ $t('info') }}</div>
          <div :class="`col-lg-${client ? 2 : 1}`">{{ $t('status') }}</div>
          <div :class="`col-lg-${client ? 4 : 3}`">{{ $t('time') }}</div>
          <div class="col-lg-1">{{ $t('total') }}</div>
          <div class="col-lg-1"></div>
        </div>
        <div class="row" v-for="item in items" :key="item._id"
          :style="!!item.excludeFromCommissionReport ? { backgroundColor: '#fff8e1' } : {}">
          <div class="col-lg-3" v-if="!client">
            <div>
              <span v-if="!item.client.utm_source" class="badge badge-primary">Tự nhiên</span>
              <span v-else-if="item.client.utm_source && item.client.utm_source === 'sales'"
                class="badge badge-success">NVKD tự tìm</span>
              <span v-else class="badge badge-warning">Marketing</span>
            </div>
            <div>
              <b>{{ $t('client') }}: </b>
              <span>{{ item.client.companyName }} ({{ item.client.domain }})</span>&nbsp;
            </div>
            <div>
              <b>{{ $t('sales') }}: </b>
              <span v-if="item.sales">{{ item.sales.name }}</span>
              <span v-else class="small">{{ $t('notUpdated') }}</span>
            </div>
            <div>
              <b>{{ $t('account') }}: </b>
              <span v-if="item.account">{{ item.account.name }}</span>
              <span v-else class="small">{{ $t('notUpdated') }}</span>
            </div>
          </div>
          <div :class="`col-lg-${client ? 4 : 3}`">
            <div><b>{{ $t('type') }}:&nbsp;</b><span>{{ $t(item.type) }}</span></div>
            <div>
              <b>{{ $t('planName') }}</b>:
              <span v-if="item.plan">{{ item.plan.name }}</span>
              <span v-else>{{ $t('privatePlan') }}</span>
            </div>
            <div v-if="item.userPrice">
              <b>{{ $t('userPrice') }}:&nbsp;</b>
              <span>{{ item.userPrice | numFormat }}</span>
            </div>
            <div v-if="item.monthCount">
              <b>{{ $t('monthCount') }}:&nbsp;</b>
              <span>{{ item.monthCount }}</span>
            </div>
            <div v-if="item.userLimit">
              <b>{{ $t('userLimit') }}:&nbsp;</b>
              <span>{{ item.userLimit }}</span>
            </div>
            <div v-if="item.numberOfUserToBuy">
              <b>{{ $t('numberOfUserToBuy') }}:&nbsp;</b>
              <span>{{ item.numberOfUserToBuy }}</span>
            </div>
            <div v-if="item.expireTime">
              <b>{{ $t('expireTime') }}:&nbsp;</b>
              <span>{{ item.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.upgradedPlan">
              <b>{{ $t('upgradedPlan') }}:&nbsp;</b>
              <span>{{ item.upgradedPlan.name }}</span>
            </div>
            <div v-if="item.upgradedPlan">
              <b>{{ $t('upgradedPrice') }}:&nbsp;</b>
              <span>{{ item.upgradedPlan.userPrice | numFormat }}</span>
            </div>
            <div v-if="item.userPriceDiff || item.userPriceDiff === 0">
              <b>{{ $t('userPriceDiff') }}:&nbsp;</b>
              <span>{{ item.userPriceDiff | numFormat }}</span>
            </div>
            <div>
              <b>{{ $t('discount') }}: </b>
              <span>{{ item.discountAmount ? item.discountAmount : 0 | numFormat }}</span>
            </div>
            <div v-if="item.numberOfDayGifted">
              <b>{{ $t('numberOfDayGifted') }}: </b><span>{{ item.numberOfDayGifted | numFormat }}</span>
            </div>
            <div v-if="item.numberOfMonthGifted">
              <b>{{ $t('numberOfMonthGifted') }}: </b><span>{{ item.numberOfMonthGifted | numFormat }}</span>
            </div>
            <div v-if="item.numberOfUserGifted">
              <b>{{ $t('numberOfUserGifted') }}: </b><span>{{ item.numberOfUserGifted | numFormat }}</span>
            </div>
            <div>
              <b>{{ $t('total') }}:&nbsp;</b>
              <span>{{ item.total | numFormat }}</span>
            </div>
            <div v-if="item.agencyCommission">
              <b>{{ $t('agencyCommission') }}:&nbsp;</b>
              <span>{{ item.agencyCommission | numFormat }}</span>
            </div>
            <div v-if="item.note">
              <b>{{ $t('note') }}:&nbsp;</b>
              <span>{{ item.note }}</span>
            </div>
          </div>
          <div :class="`col-lg-${client ? 2 : 1}`">
            <b class="c-smart-table__label">{{ $t('status') }}: </b>
            <div>
              <label v-if="!item.cancelTime && !item.confirmTime" class="badge badge-danger">{{ $t('waiting') }}</label>
              <label v-if="item.confirmTime" class="badge badge-success">{{ $t('confirmed') }}</label>
              <label v-if="item.cancelTime" class="badge badge-dark">{{ $t('canceled') }}</label>
            </div>
          </div>
          <div :class="`col-lg-${client ? 4 : 3}`">
            <div>
              <b>{{ $t('createTime') }}: </b>
              <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.confirmTime">
              <b>{{ $t('confirmTime') }}: </b>
              <span>{{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.activeTime">
              <b>{{ $t('activeTime') }}: </b>
              <span>{{ item.activeTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.extendAgainTime">
              <b>{{ $t('extendAgainTime') }}: </b>
              <span>{{ item.extendAgainTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="monthsSinceActive(item) !== ''">
              <b>{{ $t('monthsSinceActive') }}: </b>
              <span>{{ monthsSinceActive(item) }}</span>
            </div>
            <div v-if="item.cancelTime">
              <b>{{ $t('cancelTime') }}: </b>
              <span>{{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.isExtendAgain">
              <span class="badge badge-success">{{ $t('isExtendAgain') }}</span>
            </div>
          </div>
          <div class="col-lg-1">
            <div>
              <span>{{ item.total ? item.total : 0 | numFormat }}</span>
            </div>
          </div>
          <div class="col-lg-1">
            <div class="c-smart-table__content">
              <div class="c-buttons clearfix is-2">
                <div class="c-buttons__col">
                  <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1"
                    v-if="['owner'].includes($store.state.user.role)">
                    <font-awesome-icon icon="edit" />&nbsp;{{ $t('edit') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>
    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
        v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load">
      </b-pagination>
    </div>

    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <admin-user-select :model="formModel" attribute="sales" :errors="formErrors" :label="$t('sales')"
        :place-holder="$t('selectSales')"></admin-user-select>
      <admin-user-select :model="formModel" attribute="account" :errors="formErrors" :label="$t('account')"
        :place-holder="$t('selectAccount')"></admin-user-select>
      <form-checkbox :chk-label="$t('excludeFromCommissionReport')" :model="formModel"
        attribute="excludeFromCommissionReport"
        :disabled="!['owner', 'tech', 'account'].includes($store.state.user.role)"></form-checkbox>
    </b-modal>
  </div>
</template>

<script>
import List from '../../../mixins/List';
import CRUD from "../../../mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import TimeRangePicker from "../../../components/TimeRangePicker";
import BuyNew from "./BuyNew";
import BuyUser from "./BuyUser";
import Extend from "./Extend";
import Export from "./Export";
import _ from 'lodash';
import AdminUserSelect from "@/components/AdminUserSelect";
import moment from 'moment';
import Setup from "./Setup";
// import Divide from '../../client/Divide.vue';
// import Unlimited from "@/views/finance/plan-order/Unlimited";

export default {
  name: "PlanOrder",
  props: ['client'],
  components: {
    // Unlimited,
    Setup,
    AdminUserSelect,
    Extend,
    BuyUser,
    BuyNew,
    ClientSelect,
    TimeRangePicker,
    Export,
    // Divide
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/plan-order',
      autoLoad: true,
      reloadBus: 'planOrder',
      defaultFilterFormModel: {
        createTimeFrom: moment(Date.now()).startOf('day').format('x') - 29 * 24 * 60 * 60 * 1000,
        createTimeTo: moment(Date.now()).endOf('day').format('x'),
        confirmTimeFrom: null,
        confirmTimeTo: null,
        department: null,
        group: null,
        client: this.client ? this.client._id : null,
        type: null,
        status: null,
        monthsSinceActiveFrom: null,
        monthsSinceActiveTo: null,
        isExtendAgain: null,
        excludeFromCommissionReport: null,
      },
      total: 0,
      totalLoading: true
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load: _.debounce(function () {
      let loader = this.$loading.show();
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
        this.sum();
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    }, 200, { leading: true, trailing: false }),
    sum: function () {
      this.totalLoading = true;
      this.$bgService.get(this.service + "/sum", { params: this.filterFormModel }).then(response => {
        this.total = response.data && response.data.length > 0 ? response.data[0].total : 0;
      }).finally(() => {
        this.totalLoading = false
      });
    },
    // Số tháng tính từ đơn kích hoạt đầu tiên (activeTime) đến thời điểm xác nhận đơn (confirmTime).
    // Để trống nếu thiếu activeTime hoặc confirmTime.
    monthsSinceActive: function (item) {
      if ((!item.activeTime && !item.extendAgainTime) || !item.confirmTime) {
        return '';
      }
      let months = moment(item.confirmTime).diff(moment(item.activeTime), 'months', true);
      if (item.extendAgainTime) {
        months = moment(item.confirmTime).diff(moment(item.extendAgainTime), 'months', true);
      }
      return months < 0 ? '' : Math.ceil(months);
    },
  },
  i18n: {
    messages: {
      en: {
        waiting: 'Waiting',
        confirmed: 'Confirmed',
        canceled: 'Canceled',
        info: 'Info',
        type: 'Type',
        new: 'New',
        user: 'Buy user',
        upgrade: 'Upgrade',
        extend: 'Extend',
        planName: 'Plan name',
        userPrice: 'User price',
        monthCount: 'Number of month',
        userLimit: 'User limit',
        expireTime: 'Expire time',
        total: 'Total',
        note: 'Note',
        createTime: 'Create time',
        confirmTime: 'Confirm time',
        oldPlan: 'Old plan',
        upgradedPlan: 'Upgraded plan',
        upgradedPrice: 'User price after upgraded',
        userPriceDiff: 'User price difference',
        buyNew: 'Buy new',
        discount: 'Discount amount',
        numberOfDayGifted: 'Number of day to extend',
        numberOfMonthGifted: 'Number of month to extend',
        numberOfUserGifted: 'Number of user gifted',
        buyUser: 'Buy user',
        numberOfUserToBuy: 'Number of user to buy',
        allTypes: 'All types',
        sales: 'Sales',
        account: 'Account',
        noAccount: 'No sales account',
        privatePlan: 'Private plan',
        cancelTime: 'Cancel time',
        chooseBD: 'Select BD',
        chooseAM: 'Select AM',
        sum: 'Sum',
        group: 'Group',
        department: 'Department',
        setup: 'Setup',
        agencyCommission: 'Commission for agency',
        newDivide: 'Buy new due to being divided from another domain',
        promo: 'Promotion',
        unlimited: 'Unlimited (Flex)',
        companySource: "Company source",
        selfFindingSource: "Self finding source",
        allStatus: "All status",
        activeTime: "Activation time",
        monthsSinceActive: "Months since activation",
        monthFrom: "From",
        monthTo: "To",
        allReSign: "Re-sign: All",
        reSigned: "Re-signed contract",
        notReSigned: "Not re-signed",
        selectSales: "Select sales",
        selectAccount: "Select account",
        isExtendAgain: "Customer renewed",
        extendAgainTime: "Contract renewal time",
        excludeFromCommissionReport: "Exclude from commission report",
        allCommissionReport: "Commission report: All",
        excludedFromCommissionReport: "Excluded from commission report",
        includedInCommissionReport: "Included in commission report"
      },
      vi: {
        waiting: 'Đợi xác nhận',
        confirmed: 'Đã xác nhận',
        canceled: 'Đã huỷ',
        info: 'Thông tin',
        type: 'Loại',
        new: 'Mới',
        user: 'Mua user',
        upgrade: 'Nâng cấp',
        extend: 'Gia hạn',
        planName: 'Tên gói dịch vụ',
        userPrice: 'Giá/user/tháng',
        monthCount: 'Số tháng',
        userLimit: 'Số user',
        expireTime: 'Ngày hết hạn',
        total: 'Thành tiền',
        note: 'Ghi chú',
        createTime: 'Thời gian tạo',
        confirmTime: 'Thời gian xác nhận',
        oldPlan: 'Gói dịch vụ cũ',
        upgradedPlan: 'Gói dịch vụ sau nâng cấp',
        upgradedPrice: 'Giá sau nâng cấp/user/tháng',
        userPriceDiff: 'Chênh lệch giá',
        buyNew: 'Mua mới',
        discount: 'Giảm giá',
        numberOfDayGifted: 'Số ngày tặng thêm',
        numberOfMonthGifted: 'Số tháng tặng thêm',
        numberOfUserGifted: 'Số user tặng thêm',
        buyUser: 'Mua người dùng',
        numberOfUserToBuy: 'Số người dùng mua thêm',
        allTypes: 'Tất cả các loại',
        sales: 'Sales',
        account: 'Chăm sóc',
        privatePlan: 'Gói đặc biệt',
        cancelTime: 'Hủy lúc',
        chooseBD: 'Chọn BD',
        chooseAM: 'Chọn AM',
        sum: 'Tổng',
        group: 'Nhóm',
        department: 'Phòng',
        setup: 'Cài đặt',
        agencyCommission: 'Hoa hồng cho đại lý',
        newDivide: 'Mua mới do tách domain',
        promo: 'Khuyến mại',
        unlimited: 'Không giới hạn (Flex)',
        companySource: "Nguồn công ty",
        selfFindingSource: "Nguồn tự tìm",
        allStatus: "Tất cả trạng thái",
        activeTime: "Thời gian kích hoạt",
        monthsSinceActive: "Số tháng kể từ kích hoạt",
        monthFrom: "Từ",
        monthTo: "Đến",
        allReSign: "Tái ký: Tất cả",
        reSigned: "Tái ký hợp đồng",
        notReSigned: "Chưa tái ký",
        selectSales: "Chọn sales",
        selectAccount: "Chọn chăm sóc",
        isExtendAgain: "Khách hàng tái ký hợp đồng",
        extendAgainTime: "Thời gian tái ký",
        excludeFromCommissionReport: "Không tính vào báo cáo hoa hồng",
        allCommissionReport: "Báo cáo hoa hồng: Tất cả",
        excludedFromCommissionReport: "Không tính vào báo cáo hoa hồng",
        includedInCommissionReport: "Tính vào báo cáo hoa hồng"
      }
    }
  }
}
</script>